var topButtonTrigger = 1000;


$(function() {

	topButtonInit(windowScrollTop);

	$(window).scroll(function(event) {
		topButtonInit(windowScrollTop);
	});

	$('.top-button').on('click', function(event) {

		$('body, html').animate({scrollTop: 0}, animateSpeed, 'linear', function() {
			$('.top-button').removeClass('visible');
		});
	});

});


// Показывает или скрывает кнопку Наверх
function topButtonInit(scrollTop) {
	if (scrollTop >= topButtonTrigger) $('.top-button').addClass('visible');
	else $('.top-button').removeClass('visible');
}